export function updateEditor (dict, oldEditor) {
  dict = dict || {}
  let newEditor = [], keys = {}
  for (let item of oldEditor || []) {
    if (item.temporary) continue
    else if (item.name in keys) keys[item.name] = null
    else keys[item.name] = item.key
  }
  let names = Object.keys(dict)
  names.sort()
  for (let name of names) {
    newEditor.push({
      name: name,
      value: dict[name],
      key: keys[name] || Math.random() + '',
    })
  }
  let newCopy = newEditor.slice()
  let temporary = oldEditor && oldEditor.find(item => item.temporary)
  newEditor.push(temporary || {
    name: '',
    value: '',
    key: Math.random() + '',
    temporary: true,
  })
  if (!temporary) {
    return newEditor
  }
  let oldCopy = oldEditor.filter(item => !item.temporary)
  if (newCopy.length !== oldCopy.length) {
    return newEditor
  }
  oldCopy.sort((a, b) => (a.name > b.name) - (a.name < b.name))
  for (let i = 0; i < oldCopy.length; i++) {
    let a = oldCopy[i], b = newCopy[i]
    if (a.name !== b.name || a.name !== b.name) {
      return newEditor
    }
  }
  return oldEditor
}

export function editorUpdated (oldDict, editor) {
  oldDict = oldDict || {}
  let temporary = editor.find(v => v.temporary)
  if (temporary && (temporary.name || temporary.value)) {
    delete temporary.temporary
    temporary = null
  }
  if (!temporary) {
    editor.push({
      name: '',
      value: '',
      key: Math.random() + '',
      temporary: true,
    })
  }
  let newDict = {}, seen = {}
  for (let item of editor) {
    if (item.temporary) continue
    else if (!item.name || item.name in seen) {
      return oldDict
    } else {
      newDict[item.name] = item.value
    }
    seen[item.name] = true
  }
  if (!oldDict) return newDict
  for (let name in newDict) {
    if (!(name in oldDict) || oldDict[name] !== newDict[name]) {
      return newDict
    }
  }
  for (let name in oldDict) {
    if (!(name in newDict) || newDict[name] !== oldDict[name]) {
      return newDict
    }
  }
  return oldDict
}

export function deleteKey (editor, key) {
  for (let i = 0; i < editor.length; i++) {
    if (editor[i].key === key && !editor[i].temporary) {
      editor.splice(i, 1)
      return
    }
  }
  throw new TypeError('key "' + key + '" not found')
}

export function duplicateNameRule (editor, key, message) {
  return {
    validator: (rule, value, callback) => {
      if (!value) return callback()
      for (let item of editor) {
        if (item.name === value && item.key !== key) {
          return callback(new Error(message || 'Duplicate name'))
        }
      }
      return callback()
    },
  }
}

export function emptyEditor () {
  return [{
    name: '',
    value: '',
    key: Math.random() + '',
    temporary: true,
  }]
}
